import React from 'react';
import {useTranslation} from 'react-i18next';

// Modal popup shown when clicking another player's name in the players list.
// Offers "make owner" (owner only) and "vote to kick".
export default function KickPopup({target, isOwner, onClose, onMakeOwner, onVoteKick}) {
    const {t} = useTranslation();
    if (!target) return null;
    return (
        <div onClick={onClose} style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.5)', zIndex: 1000,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: 10,
        }}>
            <div onClick={e => e.stopPropagation()} style={{
                background: '#2a2a3e', borderRadius: 12, padding: '20px 28px',
                border: '1px solid #555', minWidth: 220, textAlign: 'center',
                boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
                maxHeight: 'calc(100vh - 20px)', overflowY: 'auto',
            }}>
                <div style={{fontSize: 16, color: '#eee', marginBottom: 16, fontWeight: 600}}>
                    {target}
                </div>
                <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
                    {isOwner && (
                        <button onClick={() => { onMakeOwner(target); onClose(); }} style={{
                            padding: '8px 18px', borderRadius: 6, border: '1px solid #668',
                            background: '#446', color: '#ccf', cursor: 'pointer', fontSize: 13,
                            fontWeight: 600, width: '100%',
                        }}>{t('drawing.makeOwner', 'Make room owner')}</button>
                    )}
                    <button onClick={() => { onVoteKick(target); onClose(); }} style={{
                        padding: '8px 18px', borderRadius: 6, border: '1px solid #c44',
                        background: '#a33', color: '#fff', cursor: 'pointer', fontSize: 13,
                        fontWeight: 600, width: '100%',
                    }}>{t('drawing.voteKick', 'Vote to kick')}</button>
                    <button onClick={onClose} style={{
                        padding: '6px 18px', borderRadius: 6, border: '1px solid #555',
                        background: '#444', color: '#ccc', cursor: 'pointer', fontSize: 13,
                        width: '100%',
                    }}>{t('drawing.cancel', 'Cancel')}</button>
                </div>
            </div>
        </div>
    );
}
